import Onboarding from 'app/PemetaanKompetensiPage/pages/ProfileRevamp/Onboarding'
import { checkDateTimeServer } from 'app/PemetaanKompetensiPage/utils'
import EligibilityGuard from 'app/PemetaanKompetensiPage/components/EligibilityGuard'
import RefleksiKompetensiErrorBoundary from 'app/PemetaanKompetensiPage/components/RefleksiKompetensiErrorBoundary'

export async function getServerSideProps() {
  const currentDateTimeServer = await checkDateTimeServer()
  return {
    props: { currentDateTimeServer, pageTitle: 'Refleksi Kompetensi' }, // will be passed to the page component as props
  }
}

const OnboardingPage = () => (
  <RefleksiKompetensiErrorBoundary>
    <EligibilityGuard>
      <Onboarding />
    </EligibilityGuard>
  </RefleksiKompetensiErrorBoundary>
)

OnboardingPage.layoutOpts = {
  hasHeader: false,
  className: 'text-default bg-gray-10 !max-w-full',
}

export default OnboardingPage
